package ru.villawonka.app.domain.usecase

import ru.villawonka.app.domain.model.CurrencyDomain

class GetAvailableCurrenciesUseCase {

    operator fun invoke(): List<CurrencyDomain> = CurrencyDomain.entries
}